module.exports = __webpack_public_path__ + "img/109039.0c9bed40.png";